import { t } from "src/shared/locales/i18n";
import React from "react";
import { useDispatch } from "react-redux";
import getCombinedDetail from "src/shared/util/get-combined-detail";
import { setIsCombinedModalVisible } from "../combinedProductSlice";
import useCombinedProductModal from "../hook/useCombinedProductModal";
import { DivCombinedProductModal } from "../style/CombinedProductModal.style";
import CombinedProductModalCard from "./CombinedProductModalCard";
import { isEmpty } from "lodash";
import { HighlightEvent } from "src/features/highlighted-product/model/HighlightedProduct";
import { liveHighlightDataSelector } from "src/features/highlighted-product/highlightedProductSlice";
import { useAppSelector } from "src/shared/hooks/redux";
import Portal from "src/shared/components/Portal";

interface Props {}

const CombinedProductModal = (props: Props) => {
  const highlightedProducts = useAppSelector(liveHighlightDataSelector);
  const { isVisible, combinedProducts } = useCombinedProductModal();
  const dispatch = useDispatch();

  function closeModal() {
    dispatch(setIsCombinedModalVisible(false));
  }

  if (isEmpty(highlightedProducts)) return null;
  // @ts-ignore
  const _highlightedProducts = highlightedProducts as HighlightEvent;
  if (_highlightedProducts?.item?.contentType !== "Combine") return null;

  const { combinedName, combinedCount } = getCombinedDetail(
    _highlightedProducts.item.contentObject
  );

  return (
    <>
      <Portal>
        <DivCombinedProductModal $isVisible={isVisible}>
          <div className="akn-combined-modal__content">
            <div className="akn-combined-modal__close" onClick={closeModal}>
              ✖
            </div>
            <div className="akn-combined-modal__title">
              {combinedName}
              <div className="akn-combined-modal__count">
                ({combinedCount}) {t("product")}
              </div>
            </div>

            <div className="akn-combined-modal__products">
              {Object.values(combinedProducts).map((product) => {
                return (
                  <CombinedProductModalCard
                    key={product.summary?.pk}
                    modalProduct={product}
                    isVisible={isVisible}
                  />
                );
              })}
            </div>
          </div>
        </DivCombinedProductModal>
      </Portal>
    </>
  );
};

export default CombinedProductModal;
